import api from './index'
import request from '@/utils/request'
/**
 * @description 智能进件批量进件商户
 */
function intellectBatchRegister (data) {
  return request({
    url: `${api.intellectBatchRegister}`,
    method: 'post',
    data
  })
}
/**
 * @description 银联活动列表批量导入
 */
function unionActivityBatchUpdate (data) {
  return request({
    url: `${api.unionActivityBatchUpdate}`,
    method: 'post',
    data
  })
}
export default {
  intellectBatchRegister,
  unionActivityBatchUpdate
}
